/**
 * @generated SignedSource<<aa8f1b53ca7bc7a4e56367d6357518dd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type twcSkuRecommendation_growthRecommendations$data = {
  readonly recommendations: {
    readonly __typename: "GrowthRecRecommendations";
    readonly context: {
      readonly custom: AGG$JSON | null;
    } | null;
    readonly data: ReadonlyArray<{
      readonly entityId: string;
      readonly reasons: ReadonlyArray<string> | null;
      readonly score?: number | null;
    }> | null;
  } | {
    readonly __typename: "QueryError";
    readonly extensions: ReadonlyArray<{
      readonly errorType: string | null;
      readonly statusCode: number | null;
    }> | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentType": "twcSkuRecommendation_growthRecommendations";
};
export type twcSkuRecommendation_growthRecommendations$key = {
  readonly " $data"?: twcSkuRecommendation_growthRecommendations$data;
  readonly " $fragmentSpreads": FragmentRefs<"twcSkuRecommendation_growthRecommendations">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "context"
    },
    {
      "defaultValue": 2,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "name": "twcSkuRecommendation_growthRecommendations",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "context",
          "variableName": "context"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "kind": "LinkedField",
      "name": "recommendations",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "GrowthRecContextResult",
              "kind": "LinkedField",
              "name": "context",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "custom"
                }
              ]
            },
            {
              "kind": "LinkedField",
              "name": "data",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "entityId"
                },
                {
                  "kind": "ScalarField",
                  "name": "reasons"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "score"
                    }
                  ],
                  "type": "GrowthRecNonHydratedRecommendation"
                }
              ]
            }
          ],
          "type": "GrowthRecRecommendations"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "LinkedField",
              "name": "extensions",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "errorType"
                },
                {
                  "kind": "ScalarField",
                  "name": "statusCode"
                }
              ]
            }
          ],
          "type": "QueryError"
        }
      ]
    }
  ],
  "type": "GrowthRecQuery"
};

(node as any).hash = "6dcff838299b11a0314e22ddfffd45f8";

export default node;
